const APIURL = "https://it2m.com.br/4vendor/api/"

export {APIURL}